import styled from "styled-components";
import colors from "../../constant/colors";
import fontWeights from "../../constant/fontWeights";

export const StyledContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: 10vh 20vh;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  font-family: Poppins !important;

  & .MuiTypography-root ul li {
    padding-bottom: 10px;
  }

  & .MuiTypography-root {
      width: 100%;
      max-width: 100%;
      text-align: left;
      align-self: flex-start;
      overflow-wrap: break-word;
      word-break: break-word;
    }

  & .centered {
    text-align: center;
    align-self: center;
  }

  & .MuiTypography-h3 {
    font-weight: ${fontWeights.fontWeight600};
    background: ${colors.primary};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    padding: 0px 60px 60px;
  }

  & .MuiTypography-p {
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 15px;
  }

  & .MuiTypography-h6 {
    font-family: Poppins !important;
    font-weight: ${fontWeights.fontWeight600}
    padding-bottom: 20px;
  }

  & img,
  & svg,
  & video {
    max-width: 100%;
  }

  & code {
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  & a {
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  & table {
    max-width: 100%;
  }

  /* ── Large desktop / smaller desktop ─────────────────────── */
  @media (max-width: 1440px) {
    padding: 9vh 12vh;
  }

  /* ── Laptop ──────────────────────────────────────────────── */
  @media (max-width: 1200px) {
    padding: 8vh 7vh;

    & .MuiTypography-h3 {
      padding: 0px 40px 48px;
    }
  }

  /* ── Tablet (landscape) ──────────────────────────────────── */
  @media (max-width: 992px) {
    padding: 7vh 40px;

    & .MuiTypography-h3 {
      padding: 0px 24px 40px;
    }
  }

  /* ── Tablet (portrait) / large phone ─────────────────────── */
  @media (max-width: 768px) {
    padding: 6vh 24px;

    & .MuiTypography-h3 {
      padding: 0px 12px 32px;
    }

    & .MuiTypography-root ul,
    & .MuiTypography-root ol {
      padding-left: 22px;
      margin-top: 8px;
    }

    & .MuiTypography-p {
      font-size: 15px;
      line-height: 23px;
    }
  }

  /* ── Phone ───────────────────────────────────────────────── */
  @media (max-width: 600px) {
    padding: 5vh 16px;

    & .MuiTypography-h3 {
      padding: 0px 0px 28px;
    }

    & .MuiTypography-root ul,
    & .MuiTypography-root ol {
      padding-left: 18px;
    }

    & .MuiTypography-root ul li {
      padding-bottom: 8px;
    }

    & .MuiTypography-p {
      font-size: 14px;
      line-height: 22px;
      padding-bottom: 12px;
    }
  }

  /* ── Small phone ─────────────────────────────────────────── */
  @media (max-width: 400px) {
    padding: 4vh 12px;

    & .MuiTypography-root ul,
    & .MuiTypography-root ol {
      padding-left: 16px;
    }
  }
`;
